const IMG_URL = process.env.IMG_BASE_URL;

const images = {
chat_icon : 'chat-icon',


client_logo : 'client-logo',


ic_smiley_sad_line : 'ic_smiley_sad_line',


ic_smiley_sad_fill : 'ic_smiley_sad_fill',


ic_smiley_neutral_line : 'ic_smiley_neutral_line',


ic_smiley_neutral_fill : 'ic_smiley_neutral_fill',


ic_smiley_happy_line : 'ic_smiley_happy_line',


ic_smiley_happy_fill : 'ic_smiley_happy_fill',

chatbot_ic : 'chatbot_ic',


agent_ic : 'agent_ic'
}

export {
    IMG_URL,
    images
}


// WEBPACK FOOTER //
// ./src/img/hosted_images.js